<template>
  <v-expansion-panels
    class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header> Tìm kiếm báo cáo nhân viên</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
          class="ma-0 overflow-visible"
          outlined
        >
          <validation-observer v-slot="{ handleSubmit }">
            <v-list-item class="pa-0" three-line>
              <v-list-item-content class="overflow-visible pa-0">
                <v-row>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="filterForm.ministryId"
                      :items="ministries"
                      item-text="name"
                      item-value="id"
                      label="Tìm kiếm theo bộ phận"
                      placeholder="Bộ phận"
                      color="primary"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      v-model="filterForm.shift"
                      :items="shiftListReport"
                      label="Tìm kiếm theo ca làm việc"
                      placeholder="Ca làm việc"
                      item-text="text"
                      item-value="value"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <validation-provider
                      name="Chọn ngày"
                      v-slot="{ errors }"
                      rules="required"
                    >
                      <common-range-picker
                        v-model="selectRange"
                        :clearable="true"
                        :aLight="'left'"
                        :defaultRange="defaultRange"
                        @change-date-range="changeDateRange"
                      />
                      <div class="v-text-field__details mt-1">
                        <div class="v-messages theme--light error--text" role="alert">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">
                              {{ errors[0] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </validation-provider>
                  </v-col>
                </v-row>
                <div class="text-center mb-4">
                  <v-btn
                          class="primary mx-0"
                          @click.prevent="handleSubmit(searchReport);"
                  >
                    <v-icon>mdi-magnify</v-icon>Tìm kiếm
                  </v-btn>
                </div>
              </v-list-item-content>
            </v-list-item>
          </validation-observer>

        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
  import { shiftListReport } from '../../../../helpers/constants'
  import RepositoryFactory from '../../../../repositories/RepositoryFactory'
  import * as moment from 'moment'

  const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
  export default {
    components: {
    },
    props: {
      filterForm: {
        default: () => ({}),
      },
    },
    data () {
      return {
        shiftListReport,
        ministries: [],
        defaultRange: {
          startDate: moment().startOf('days').format('YYYY-MM-DD 00:00:00'),
          endDate: moment().endOf('days').format('YYYY-MM-DD 23:59:59'),
        },
        selectRange: [{
          startDate: moment().startOf('days').format('YYYY-MM-DD 00:00:00'),
          endDate: moment().endOf('days').format('YYYY-MM-DD 23:59:59'),
        }],
      }
    },
    created () {
      this.getMinistryList()
    },
    methods: {
      searchReport () {
        Bus.$emit('report-employees-list-filter', this.filterForm)
      },

      async getMinistryList () {
        const response = await OrganizationMachineRepository.listMinistryOnly()
        if (_.get(response, 'success', false)) {
          const ministries = [
            {
              id: '',
              name: 'Tất cả'
            }
          ]
          ministries.push(..._.get(response, 'data', []))
          this.ministries = ministries
        }
      },
      changeDateRange (dateRange) {
        this.filterForm.dateRange = dateRange
      }
    }
  }
</script>
